export default [
  "#ac4dff",
  "#ff4d58",
  "#ff884d",
  "#ffc64d",
  "#7cff4d",
  "#4dff5b",
  "#4da9ff",
  "#4d6aff",
  "#6d4dff",
  "#ea4dff",
  "#ff4dd5",
  "#ff4d97",
  "#ffbb4d",
  "#88ff4d",
  "#4dff4f",
  "#4d76ff",
  "#614dff",
  "#a04dff",
  "#de4dff",
  "#ff4de1",
  "#ff4da3",
  "#ff4d64",
  "#ff734d",
  "#55ff4d",
  "#4d82ff",
  "#554dff",
  "#944dff",
  "#d24dff",
  "#ff4ded",
  "#ff4daf",
  "#ff4d70",
  "#ff674d",
  "#ffa64d",
  "#deff4d",
  "#a0ff4d",
  "#61ff4d",
  "#4dff76",
  "#4dffb5",
  "#4dfff3",
  "#4dccff",
  "#4d8eff",
  "#4d4fff",
  "#884dff",
  "#c64dff",
  "#ff4df9",
  "#ff4dbb",
  "#ff4d7c",
  "#ff5b4d",
  "#ff9a4d",
  "#ffd84d",
  "#acff4d",
  "#6dff4d",
  "#4dff6a",
  "#4dffa9",
  "#4dffe7",
  "#4dd8ff",
  "#4d9aff",
  "#4d5bff",
  "#7c4dff",
  "#bb4dff",
  "#f94dff",
  "#ff4dc6",
  "#ff4d88",
  "#ff4f4d",
  "#ff8e4d",
  "#ffcc4d",
  "#f3ff4d",
  "#79ff4d",
  "#4dff5e",
  "#4dff9d",
  "#4dffdb",
  "#4de4ff",
  "#4da6ff",
  "#4d67ff",
  "#704dff",
  "#af4dff",
  "#ed4dff",
  "#ff4dd2",
  "#ff4d94",
  "#ff4d55",
  "#ff824d",
  "#ffc14d",
  "#ffff4d",
  "#c1ff4d",
  "#4dff52",
  "#4dff91",
  "#4dffcf",
  "#4df0ff",
  "#4db2ff",
  "#4d73ff",
  "#644dff",
  "#a34dff",
  "#e14dff",
  "#ff4dde",
  "#ff4da0",
  "#ff4d61",
  "#ff764d",
  "#ffb54d",
  "#fff34d",
  "#ccff4d",
  "#8eff4d",
  "#4dff85",
  "#4dffc3",
  "#4dfcff",
  "#4dbeff",
  "#4d7fff",
  "#584dff",
  "#974dff",
  "#d54dff",
  "#ff4dea",
  "#ff4dac",
  "#ff4d6d",
  "#ff6a4d",
  "#ffa94d",
  "#ffe74d",
  "#d8ff4d",
  "#9aff4d",
  "#5bff4d",
  "#4dffb8",
  "#4dfff6",
  "#4dc9ff",
  "#4d8bff",
  "#4d4dff",
  "#8b4dff",
  "#c94dff",
  "#ff4df6",
  "#ff4db8",
  "#ff4d79",
  "#ff5e4d",
  "#ff9d4d",
  "#ffdb4d",
  "#e4ff4d",
  "#a6ff4d",
  "#67ff4d",
  "#4dff70",
  "#4dffea",
  "#4dd5ff",
  "#4d97ff",
  "#4d58ff",
  "#7f4dff",
  "#be4dff",
  "#fc4dff",
  "#ff4dc3",
  "#ff4d85",
  "#ff524d",
  "#ff914d",
  "#ffcf4d",
  "#f0ff4d",
  "#b2ff4d",
  "#73ff4d",
  "#4dff64",
  "#4dffa3",
  "#4de1ff",
  "#4da3ff",
  "#4d64ff",
  "#734dff",
  "#b24dff",
  "#f04dff",
  "#ff4dcf",
  "#ff4d91",
  "#ff4d52",
  "#ff854d",
  "#ffc44d",
  "#fcff4d",
  "#beff4d",
  "#7fff4d",
  "#4dff58",
  "#4dff97",
  "#4dffd5",
  "#4dafff",
  "#4d70ff",
  "#674dff",
  "#a64dff",
  "#e44dff",
  "#ff4ddb",
  "#ff4d9d",
  "#ff4d5e",
  "#ff794d",
  "#ffb84d",
  "#fff64d",
  "#c9ff4d",
  "#8bff4d",
  "#4dff4d",
  "#4dff8b",
  "#4dffc9",
  "#4df6ff",
  "#4d7cff",
  "#5b4dff",
  "#9a4dff",
  "#d84dff",
  "#ff4de7",
  "#ff4da9",
  "#ff4d6a",
  "#ff6d4d",
  "#ffac4d",
  "#ffea4d",
  "#d5ff4d",
  "#97ff4d",
  "#58ff4d",
  "#4dff7f",
  "#4dffbe",
  "#4dfffc",
  "#4dc3ff",
  "#4f4dff",
  "#8e4dff",
  "#cc4dff",
  "#ff4df3",
  "#ff4db5",
  "#ff4d76",
  "#ff614d",
  "#ffa04d",
  "#ffde4d",
  "#e1ff4d",
  "#a3ff4d",
  "#64ff4d",
  "#4dff73",
  "#4dffb2",
  "#4dfff0",
  "#4dcfff",
  "#4d91ff",
  "#824dff",
  "#c14dff",
  "#ff4dff",
  "#ff4dc1",
  "#ff4d82",
  "#ff554d",
  "#ff944d",
  "#ffd24d",
  "#edff4d",
  "#afff4d",
  "#70ff4d",
  "#4dff67",
  "#4dffa6",
  "#4dffe4",
  "#4ddbff",
  "#4d9dff",
  "#4d5eff",
  "#b54dff",
  "#f34dff",
  "#ff4dcc",
  "#ff4d8e",
  "#ff4d4f",
  "#ff884d",
  "#ffc64d",
  "#f9ff4d",
  "#bbff4d",
  "#7cff4d",
  "#4dff5b",
  "#4dff9a",
  "#4dffd8",
  "#4de7ff",
  "#4da9ff",
  "#4d6aff",
  "#4d4dff",
  "#e74dff",
  "#ff4dd8",
  "#ff4d9a",
  "#ff4d5b",
  "#ff7c4d",
  "#ffbb4d",
  "#fff94d",
  "#c6ff4d",
  "#88ff4d",
  "#4dff4f",
  "#4dff8e",
  "#4dffcc",
  "#4df3ff",
  "#4db5ff",
  "#4d76ff",
  "#4d4dff",
  "#4d4dff",
  "#ff4de4",
  "#ff4da6",
  "#ff4d67",
  "#ff704d",
  "#ffaf4d",
  "#ffed4d",
  "#d2ff4d",
  "#94ff4d",
  "#55ff4d",
  "#4dff82",
  "#4dffc1",
  "#4dffff",
  "#4dc1ff",
  "#4d82ff",
  "#4d4dff",
  "#4d4dff",
  "#4d4dff",
  "#ff4db2",
  "#ff4d73",
  "#ff644d",
  "#ffa34d",
  "#ffe14d",
  "#deff4d",
  "#a0ff4d",
  "#61ff4d",
  "#4dff76",
  "#4dffb5",
  "#4dfff3",
  "#4dccff",
  "#4d8eff",
  "#4d4fff",
  "#4d4dff",
  "#4d4dff",
  "#4d4df9",
  "#ff4d7f",
  "#ff584d",
  "#ff974d",
  "#ffd54d",
  "#eaff4d",
  "#acff4d",
  "#6dff4d",
  "#4dff6a",
  "#4dffa9",
  "#4dffe7",
  "#4dd8ff",
  "#4d9aff",
  "#4d5bff",
  "#4d4dff",
  "#4d4dff",
  "#4d4dff",
  "#4d4dc6",
  "#ff4d4d",
  "#ff8b4d",
  "#ffc94d",
  "#f6ff4d",
  "#b8ff4d",
  "#79ff4d",
  "#4dff5e",
  "#4dff9d",
  "#4dffdb",
  "#4de4ff",
  "#4da6ff",
  "#4d67ff",
  "#4d4dff",
  "#4d4dff",
  "#4d4dff",
  "#4d4dd2",
  "#4d4d94",
  "#ff7f4d",
  "#ffbe4d",
  "#fffc4d"
];
